var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.playbackId)?_c('mux-player',{attrs:{"stream-type":"on-demand","playback-id":_vm.playbackId,"metadata-video-title":_vm.title,"metadata-viewer-user-id":_vm.viewerId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }